import DashboardLayout from '../layout/DashboardLayout.vue'

import NotFound from '../pages/NotFoundPage.vue'

import Overview from 'src/pages/Overview.vue'
import Login from 'src/pages/Login.vue'
import Transactions from 'src/pages/Transactions.vue'
import Orders from  'src/pages/Orders.vue'
import Icons from 'src/pages/Icons.vue'

const routes = [
  {
    path: '/',
    component: Login,
  },
  {
    path: '/board',
    component: DashboardLayout,
    redirect: '/board/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'transactions',
        name: 'Transactions',
        component: Transactions
      },
      {
        path: 'orders',
        name: 'Orders',
        component: Orders
      },
      {
        path: 'icons',
        name: 'Icons',
        component: Icons
      },
    ]
  },
  { path: '*', component: NotFound }
]

export default routes
